export default __webpack_public_path__ + "f5d3a4535f8f61dbc521357ae841c1e5.svg";